import { render, staticRenderFns } from "./YMmpStoreItem.vue?vue&type=template&id=28997d6a&scoped=true&"
import script from "./YMmpStoreItem.vue?vue&type=script&lang=js&"
export * from "./YMmpStoreItem.vue?vue&type=script&lang=js&"
import style0 from "./YMmpStoreItem.vue?vue&type=style&index=0&id=28997d6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28997d6a",
  null
  
)

export default component.exports